// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".logo[data-v-294f9c9a]{display:flex;flex-shrink:0}.logo__img-pods[data-v-294f9c9a]{height:2.1875rem;width:7.3125rem}.logo__img-parkings[data-v-294f9c9a]{height:2rem;max-height:2rem;-o-object-fit:contain;object-fit:contain;width:auto}@media (min-width:1024px){.logo__img-parkings[data-v-294f9c9a]{height:2.5rem;max-height:2.5rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
